<template>
  <div>
    <v-container>
      <HandleCreateNewFYAdditionalDataGrp
      :dialog="showAdditionalDataGrpDialog"
      :response="aditionalDataResultObj"
      :programName="programName"
      @openCloseDialog="openCloseDialog"
      />
      <v-dialog
      v-model="isDialog"
      persistent
      max-width="60vw">
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-card
        class="CreateMiscNewFiscalYear">
          <v-card-title>
            Would you like to create New Fiscal Year For {{ nextFiscalYear }}?
          </v-card-title>
          <v-card-text>
            <v-btn
              color="blue darken-1"
              text
              @click="performAction"
            >
              Yes
            </v-btn>
            <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { calculateFiscalYears } from '../../../util/shared/tmc-global';
import { isEmptyObject } from '../../../util/shared/vue-global';
import HandleCreateNewFYAdditionalDataGrp from '../../common/createNewFiscalYear/HandleCreateNewFYAdditionalDataGrp.vue';

export default {
  name: 'MiscCreateFiscalYear',
  components: {
    HandleCreateNewFYAdditionalDataGrp,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fundBaseCrudKey: 'sharedFund',
    miscReceiptsBaseCrudKey: 'miscTransaction',
    currentFiscalYear: undefined,
    nextFiscalYear: undefined,
    funds: [],
    selectedFundList: [],
    overlay: false,
    programName: '',
    showAdditionalDataGrpDialog: false,
    aditionalDataResultObj: {},
  }),
  created() {
    this.initializeDialogBox();
  },
  computed: {
    ...mapState({
      regYears: (state) => state.misc.miscTransaction.regYears,
    }),
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    isDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('dialogVal', value);
      },
    },
    fundList() {
      return this.items(this.fundBaseCrudKey);
    },
    fiscalYearList() {
      const registerdYears = (this.regYears || {});
      const allowAll = false;
      return calculateFiscalYears(registerdYears, allowAll);
    },
  },
  methods: {
    ...mapActions('misc/miscTransaction', [
      'loadFiscalRegYears',
    ]),
    ...mapActions('createNewFiscalYearManager', ['createNewFiscalYear']),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    initializeDialogBox() {
      this.loadFiscalRegYears({ baseCrudKey: this.miscReceiptsBaseCrudKey }).then(() => {
        const regYears = this.fiscalYearList || [];
        if ((regYears || []).length > 0) {
          this.currentFiscalYear = (regYears[regYears.length - 1] || {}).year;
          this.nextFiscalYear = this.currentFiscalYear + 1;
          this.fetchFunds(this.nextFiscalYear);
        }
      }).catch((e) => {
        console.warn(e);
      });
    },
    async handleCreateNewFiscalYearResult(resultObj) {
      if (!isEmptyObject(resultObj)) {
        if ((resultObj.componentStatusArr || []).length > 0) {
          this.showAdditionalDataGrpDialog = true;
          this.aditionalDataResultObj = resultObj;
          this.programName = resultObj.programName;
        }
      }
    },
    async miscCreateNewFiscalYear() {
      this.selectedFundList = (this.fundList || [])
        .filter((f) => (this.funds || []).includes(f._id));
      const result = await this.createNewFiscalYear({
        programName: this.miscReceiptsBaseCrudKey,
        nextFiscalYear: this.nextFiscalYear,
        currentFiscalYear: this.currentFiscalYear,
        params: {
          fundsList: this.selectedFundList,
        },
      });
      return result;
    },
    async performAction() {
      this.overlay = true;
      const resultObj = await this.miscCreateNewFiscalYear();
      this.handleCreateNewFiscalYearResult(resultObj);
      this.overlay = false;
      this.close();
    },
    close() {
      this.isDialog = false;
    },
    loadFundData() {
      this.funds = this.mapCollectionVal(this.fundList, '_id');
    },
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    createSelectedFunds() {
      this.selectedFundList = (this.fundList || [])
        .filter((f) => (this.funds || []).includes(f._id));
    },
    async fetchFunds(fiscalYear) {
      const inputFiscalYear = fiscalYear - 1;
      await this.loadFunds({
        criteria: {
          fiscalYear: inputFiscalYear,
        },
        baseCrudKey: this.fundBaseCrudKey,
      });
      this.loadFundData();
    },
    openCloseDialog(value) {
      this.showAdditionalDataGrpDialog = value;
    },
  },
};
</script>

<style>

</style>
